var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "358px",
    height: "200px",
    viewBox: "0 0 358 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L352,0 C355.313708,-6.08718376e-16 358,2.6862915 358,6 L358,200 L358,200 L0,200 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "81.1767625%",
    x2: "50%",
    y2: "-34.5130789%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C19",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC967",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.1100647%",
    y1: "31.3809088%",
    x2: "62.1100647%",
    y2: "-27.4779882%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAD4FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.9517939,0.0643082741 L25.6904111,0.0643082741 C26.3660502,0.0643082741 26.913764,0.60314908 26.913764,1.2678429 L26.913764,4.57756312 C31.3993913,10.1439108 33.642205,15.7102584 33.642205,21.276606 C33.642205,26.6715109 31.7269463,32.0664157 27.896429,37.4613205 C27.6675817,37.7836241 27.2931485,37.975649 26.8935237,37.975649 L6.748676,37.975649 C6.34905097,37.975649 5.97461756,37.7836214 5.74577265,37.4613159 C1.91525755,32.0664126 0,26.6715093 0,21.276606 C0,15.8152838 2.15897762,10.3539616 6.47693287,4.8926394 L6.72844099,4.57756312 L6.72844099,1.2678429 C6.72844099,0.60314908 7.27615474,0.0643082741 7.9517939,0.0643082741 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Knowledge-Base",
    transform: "translate(-1052.000000, -791.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(1052.000000, 791.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(178.000000, 136.500000) scale(-1, 1) translate(-178.000000, -136.500000) translate(66.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.11136,135.5 L100,135.5 L100,135.5 L100,201.5 C100,203.709139 98.209139,205.5 96,205.5 L18,205.5 C15.790861,205.5 14,203.709139 14,201.5 L14,159.61136 C14,146.295024 24.7950236,135.5 38.11136,135.5 Z",
    id: "Rectangle",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5803656,62.7956067 L100,62.5 L100,62.5 L100,142.5 L63,142.5 L63,86.901119 C63,73.7916957 73.4741217,63.08431 86.5803656,62.7956067 Z",
    id: "Rectangle",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.11136,62.5 L148.16,62.5 C160.221899,62.5 170,72.2781011 170,84.34 L170,141.7528 C170,142.717752 169.217752,143.5 168.2528,143.5 L70,143.5 L70,143.5 L70,86.61136 C70,73.2950236 80.7950236,62.5 94.11136,62.5 Z",
    id: "Rectangle",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,62.5 C163.731986,62.5 170,68.7680135 170,76.5 L170,133.7528 C170,134.717752 169.217752,135.5 168.2528,135.5 L142,135.5 L142,135.5 L142,76.5 C142,68.7680135 148.268014,62.5 156,62.5 Z",
    id: "Rectangle",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6,143.5 L96,143.5 L96,143.5 L96,196.5 L22,196.5 L22,156.1 C22,149.141212 27.6412122,143.5 34.6,143.5 Z",
    id: "Rectangle",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Wom1.4",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(67.000000, 112.500000) scale(-1, 1) translate(-67.000000, -112.500000) translate(0.000000, 8.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(26.641267, 0.378756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1469457,46.3186884 C-1.7852142,44.0040155 -2.43933432,30.3610614 5.11182835,25.6285504 C-2.67561043,9.29203187 15.3329111,-6.92800719 27.6685858,3.07515321 C35.755572,-0.388984977 42.4759625,13.1287933 34.9509646,23.6275629 C38.1060606,41.654256 31.6848041,46.3139752 20.1094945,46.5119269 L8.1469457,46.3186884 Z",
    id: "Path",
    fill: "#33373E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27051177,43.0603672 C8.27051177,43.0603672 13.1020342,41.9252786 13.2696475,34.0027689 C13.4372608,26.0802591 13.3195985,23.3759195 13.3195985,23.3759195 L23.9620139,23.1837442 C23.9620139,23.1837442 24.0780231,32.0132542 24.0796763,35.2069192 C24.0841163,43.7846658 30.0565931,43.0603672 30.0565931,43.0603672 C30.0565931,43.0603672 28.8150302,50.0155252 19.1717139,50.5581705 C11.6424345,50.9825113 8.27051177,43.0603672 8.27051177,43.0603672 Z",
    id: "Path",
    fill: "#EDC2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8387307,19.4197633 C6.09116651,19.2359193 6.8655494,26.191094 11.7973772,26.1816519 C11.7973772,26.1816519 14.6618581,36.0618898 24.6069681,36.0618898 C32.6836799,36.0618898 33.2090838,24.5462892 33.2823452,22.2490724 C33.3611568,19.7996705 33.371147,11.7527467 33.371147,11.7527467 L10.653912,11.7421937 L10.8387307,19.4197633 Z",
    id: "Path",
    fill: "#FFD7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8656637,28.6327248 C22.8656637,28.6327248 24.4982608,31.2736926 27.6882171,30.3339201",
    id: "Path",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(25.276940, 29.584425) rotate(-18.000000) translate(-25.276940, -29.584425) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2493638,31.7850762 C24.9978504,32.0994549 25.7077829,32.0994732 26.3290047,31.7382425",
    id: "Path",
    stroke: "#F49494",
    strokeLinecap: "round",
    transform: "translate(25.289184, 31.876780) rotate(2.000000) translate(-25.289184, -31.876780) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0573784,23.2772966 C11.3559081,22.2012046 11.223855,21.2613774 10.1560075,20.8321243",
    id: "Path-8",
    stroke: "#F77B7B",
    strokeLinecap: "round",
    transform: "translate(10.676100, 22.054710) rotate(-13.000000) translate(-10.676100, -22.054710) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0875813,18.5604193 C10.0875813,18.5604193 12.6897844,22.054716 13.216892,22.0732758 C13.7439996,22.0918355 13.9285747,17.5287665 13.9285747,17.5287665 C17.1206809,17.2847308 25.1992405,15.6748276 27.1795419,11.9243414 C28.5644238,15.2335548 31.2117761,16.7034442 32.9511806,16.4211798 L33.2808572,23.4516058 L34.092759,9.31746176 L9.45110201,9.31746176 L10.0875813,18.5604193 Z",
    id: "Path",
    fill: "#33373E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(30.040367, 107.250000)",
    fill: "#33373E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6345894,0.0256888086 C24.0429096,0.356707974 65.2755331,9.4831806 72.766803,11.0337045 C80.2580729,12.5842283 86.5914565,20.9742232 80.8790168,30.689373 C74.4630229,41.5951409 57.9085839,72.5672689 53.8892947,79.5491528 C51.8999148,83.004893 41.863828,81.0673443 44.2212594,75.2671459 C48.6159347,64.4545355 50.6568262,37.2922277 61.8611887,27.3884495 C61.8611887,27.3884495 24.1810415,33.951072 7.90478857,26.4337844 C-3.92437201,20.9693411 -1.24828721,-0.774536887 16.6345894,0.0256888086 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(52.383906, 45.760000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.782236,17.6753496 C46.782236,17.6753496 46.6985217,11.643004 48.8070746,8.49047147 C50.9156275,5.33793893 50.9993417,1.98925813 52.5951448,2.09887039 C54.1909478,2.20848265 52.6108412,9.99200211 52.6108412,9.99200211 C52.6108412,9.99200211 54.6356798,9.21789829 56.090215,8.23873039 C57.5447503,7.25956249 61.9554452,2.43242732 62.986177,3.28782252 C64.7337122,4.74529847 61.9188202,12.9667425 60.3858029,14.610402 C58.8475534,16.2545859 50.4447348,21.66125 50.4447348,21.66125 L46.782236,17.6753496 Z",
    id: "Path",
    fill: "#FFD7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2557163,14.0606471 C4.70189067,22.0595605 11.0119219,36.7538499 13.6132585,41.1378238 C16.8732821,46.6280608 22.0139051,49.0469368 28.0327775,44.9734427 C34.357128,40.6931213 51.7714231,23.9985917 52.2821442,20.2169485 C52.7880922,16.4353054 48.5257187,11.8980023 44.6690581,14.2471397 C40.8123976,16.5962772 24.7870731,29.9424022 24.7870731,29.9424022 C24.7870731,29.9424022 18.3195298,13.3513204 13.1168566,3.74030071 C8.61105522,-4.57482429 -3.98991477,1.90035003 1.2557163,14.0606471 Z",
    id: "Path",
    fill: "#675CD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8538965,29.9510001 C26.0119333,33.8817393 26.7263065,35.7333131 26.997016,35.5057214 C27.2677255,35.2781297 27.1643084,32.9129109 26.6867648,28.4100652 L24.8538965,29.9510001 Z",
    id: "Path",
    fillOpacity: 0.302802666,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PhoneMini4",
    transform: "translate(110.397617, 56.908205) scale(-1, 1) rotate(-18.000000) translate(-110.397617, -56.908205) translate(102.397617, 42.408205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83401927,1.00879985 L11.6739699,1.00879985 C12.9994533,1.00879985 14.0739699,2.08331645 14.0739699,3.40879985 L14.0739699,25.9087998 C14.0739699,27.2342832 12.9994533,28.3087998 11.6739699,28.3087998 L2.83401927,28.3087998 C1.50853587,28.3087998 0.434019271,27.2342832 0.434019271,25.9087998 L0.434019271,3.40879985 C0.434019271,2.08331645 1.50853587,1.00879985 2.83401927,1.00879985 Z",
    id: "Rectangle",
    fill: "#7596FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#93C2F9",
    x: 1.46142328,
    y: 0.65,
    width: 13.6399506,
    height: 27.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89946706,1.625 L4.93393862,1.625 C5.14468559,1.625 5.31996341,1.77697337 5.35631222,1.97738404 L5.36322866,2.05460632 C5.36322866,2.29187134 5.55542835,2.48421264 5.79251869,2.48421264 L10.7807215,2.48421264 C10.9914685,2.48421264 11.1667463,2.33223927 11.2030951,2.1318286 L11.2100115,2.05460632 C11.2100115,1.8173413 11.4022112,1.625 11.6393016,1.625 L12.6685516,1.625 C13.4331281,1.625 14.0601781,2.21425494 14.1209716,2.96371911 L14.1258018,3.0846141 L14.1258018,3.0846141 L14.1061827,25.2849594 C14.103775,26.2536113 13.3188643,27.0384059 12.3509238,27.039961 L4.16695342,27.039961 C3.24051797,27.0414427 2.48186708,26.3226068 2.41764874,25.4118449 L2.41324548,25.2865101 C2.41324548,25.2859928 2.41324548,25.2854754 2.41479643,25.2849594 L2.43441094,3.08983947 C2.43512607,2.2806215 3.09084454,1.625 3.89946706,1.625 Z",
    id: "Rectangle",
    fill: "#E6F3FF",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(19.199222, 42.033012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8.14953369 C0,8.14953369 8.30470904,35.9779761 8.55065821,41.2456897 C8.79660737,46.513927 1.75827488,61.9970984 2.95662294,65.9105713 C5.71962633,74.9540295 40.9950162,78.8481262 42.3427415,66.682478 C42.9712774,61.008809 41.6632494,55.9166309 43.1703422,49.231311 C44.672202,42.5459912 50.709048,32.6115126 47.2850352,23.2713647 C43.8610225,13.9312169 44.7784469,5.29012788 42.3294212,3.6568689 C39.8803955,2.02360991 34.1555362,0.289072266 34.1555362,0.289072266 C31.371601,4.38897583 21.9732031,4.32927612 17.4885555,-4.61852778e-14 C17.4885555,-4.61852778e-14 6.34758164,2.16280518 0,8.14953369 Z",
    id: "Path",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44204499,12.6566474 C12.9777608,21.4481993 12.9611181,36.7551158 15.9341961,38.7597961 C18.9072742,40.7644763 30.478776,38.7972168 30.478776,40.3847961 C30.478776,41.9723753 14.4876884,56.5216394 17.1128512,63.4768685 C18.487435,67.1187554 18.1145696,70.3768698 15.9942549,73.2512117 L15.3021518,73.1002818 C9.00153325,71.6753127 3.93611742,69.1165093 2.95662294,65.9105713 C1.75827488,61.9970984 9.60850919,46.513927 9.36256003,41.2456897 C9.1537815,36.7740929 2.553,16.0457331 0.562598119,9.88245598 C2.18310029,7.0213655 4.47585674,7.94589292 7.44204499,12.6566474 Z",
    id: "Path",
    fillOpacity: 0.199355332,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(0.000000, 47.856250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0809169,30.1578931 C36.0809169,30.1578931 43.075914,23.9623394 45.2172396,23.2433531 C47.3585653,22.5243668 59.8998601,21.6606393 59.8205517,23.2853071 C59.7306689,25.0258727 52.9947458,24.9257076 52.2968323,25.7820932 C51.5989187,26.6379543 51.440302,32.4905342 48.8019774,33.1476384 C46.1689399,33.8047426 38.2751148,34.9375 38.2751148,34.9375 L36.0809169,30.1578931 Z",
    id: "Path",
    fill: "#FFD7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4714673,3.92556582 C10.1018091,14.3342796 3.80977615,30.1892887 1.39459023,36.3707014 C-1.02059568,42.5521142 1.41572822,51.8756501 12.0358639,50.0452526 C22.6369072,48.2196317 39.5040724,38.3000398 41.3703525,35.4063687 C43.2366325,32.5126975 40.4014142,27.2473706 36.8311394,27.9366356 C33.5233848,28.5743133 17.1162127,35.5558766 17.1162127,35.5558766 C17.1162127,35.5558766 27.6715707,16.8324473 30.2490418,11.8131841 C34.5543732,3.43070889 23.9628761,-5.24552793 17.4714673,3.92556582 Z",
    id: "Path",
    fill: "#675CD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.283271,35.4278634 C13.5975855,37.2603447 11.9795064,37.7923228 12.4290337,37.0237975 C12.878561,36.2552723 15.1998761,34.5210212 19.3929789,31.8210442 L17.283271,35.4278634 Z",
    id: "Path",
    fillOpacity: 0.302802666,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(17.861840, 104.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.78857772,0.143374092 C-2.39165108,15.3184151 -0.936489279,25.5113336 9.15406313,30.7221294 C23.7916574,38.2810332 67.6116278,29.3408794 67.6116278,29.3408794 C67.6116278,29.3408794 66.8286028,35.6497722 67.6116278,41.2765442 C69.6566966,55.972289 79.382855,80.4561508 81.4406691,83.5326077 C84.2863881,87.7869921 92.9550159,84.5785271 93.1183018,81.0360844 C93.2815876,77.4936417 86.5834487,32.2506833 85.5648703,23.6231679 C84.5515423,14.9951271 81.3523503,13.7418728 72.0083267,11.3833402 C69.8616678,10.8415002 44.4761086,4.52813002 42.1505735,4.71214591 C28.829399,5.76622925 16.3754004,4.24330531 4.78857772,0.143374092 Z",
    id: "Path",
    fill: "#42474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5952732,28.3729641 C31.0869804,29.9979641 69.4531766,26.6483856 70.9940489,28.170438 C72.4651592,29.6235806 72.2197082,54.9050083 75.5197479,69.537678 L75.0178684,68.1559 C71.9143075,59.5296283 68.6917127,49.0379716 67.6116278,41.2765442 C66.8286028,35.6497722 67.6116278,29.3408794 67.6116278,29.3408794 L65.8447531,29.6831351 C57.5150611,31.2489299 22.0351461,37.3739648 9.15406313,30.7221294 C2.17465151,27.1179373 -0.673431635,21.1302069 0.609813693,12.758938 C2.81949775,22.2208558 8.1479704,27.4257418 16.5952732,28.3729641 Z",
    id: "Path",
    fill: "#52565E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#52565E",
    transform: "translate(91.744906, 24.781250) rotate(13.000000) translate(-91.744906, -24.781250) ",
    cx: 91.7449058,
    cy: 24.78125,
    rx: 2.43579558,
    ry: 4.46858339
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#52565E",
    transform: "translate(80.378280, 21.937500) rotate(-16.000000) translate(-80.378280, -21.937500) ",
    cx: 80.3782803,
    cy: 21.9375,
    rx: 3.24778817,
    ry: 4.87472701
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M108.11136,135.5 L170,135.5 L170,135.5 L170,203.7528 C170,204.717752 169.217752,205.5 168.2528,205.5 L84,205.5 L84,205.5 L84,159.61136 C84,146.295024 94.7950236,135.5 108.11136,135.5 Z",
    id: "Rectangle",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(23.000000, 11.500000) scale(-1, 1) translate(-23.000000, -11.500000) translate(8.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.86233449,0 L4.11011187,0 C5.00180714,5.82428401e-17 5.72466899,0.722861846 5.72466899,1.61455712 L5.72466899,2.00983744 C5.72466899,2.68322543 6.27055781,3.22911424 6.94394579,3.22911424 L22,3.22911424 C24.209139,3.22911424 26,5.01997524 26,7.22911424 L26,18 C26,20.209139 24.209139,22 22,22 L4,22 C1.790861,22 2.705415e-16,20.209139 0,18 L0,2.86233449 C-1.93595067e-16,1.2815108 1.2815108,2.90392601e-16 2.86233449,0 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18377012,2 L25.5742882,2 C26.2476761,2 26.793565,2.54588882 26.793565,3.2192768 C26.793565,3.28262157 26.7886286,3.34587003 26.7788006,3.40844775 L24.0207423,20.9698942 C23.9275974,21.5629781 23.4165836,22 22.8162299,22 L4.42571184,22 C3.75232385,22 3.20643504,21.4541112 3.20643504,20.7807232 C3.20643504,20.7173784 3.21137143,20.65413 3.22119938,20.5915522 L5.97925766,3.03010585 C6.07240261,2.43702188 6.5834164,2 7.18377012,2 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0746951,11.7628407 L28.1493901,16.5256815 C27.4189648,20.2854143 24.1262467,23 20.2962191,23 L4.85189047,23 C2.64275147,23 0.851890471,21.209139 0.851890471,19 C0.851890471,18.7439562 0.876474761,18.4885038 0.925304931,18.2371593 L1.85060986,13.4743185 C2.58103515,9.71458569 5.87375326,7 9.70378094,7 L25.1481095,7 C27.3572485,7 29.1481095,8.790861 29.1481095,11 C29.1481095,11.2560438 29.1235252,11.5114962 29.0746951,11.7628407 Z",
    id: "Rectangle",
    fill: "#FFCC7B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-79",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(176.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9793783,58.2341343 C30.3457527,43.9908717 36.1295112,29.3627805 41.4243368,14.4117401 C29.2281594,25.7800147 19.7440494,39.6299095 21.094578,58.2341343 L23.9793783,58.2341343 Z",
    id: "Path-113",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5861446,59.72149 C19.079344,35.4349795 19.7178446,12.879603 32.3470116,0 C30.6050123,26.6653355 27.3463842,45.4498771 23.2192603,59.72149 L20.5861446,59.72149 Z",
    id: "Rectangle",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0066999,57.1923582 C12.950821,40.2208659 5.86072321,35.3560185 2.45563569e-14,17.9350541 C19.1807249,27.7711831 20.3830768,35.8932679 24.1479585,57.1923582 L20.0066999,57.1923582 Z",
    id: "Path-112",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.209218,57.1923582 L3.55146345,40.2208659 C9.66463154,41.944202 19.8826357,44.7348338 19.8826357,57.1923582 L16.209218,57.1923582 Z",
    id: "Path-114",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0478916,57.1923582 L32.2705097,57.1923582 C34.9538941,51.6512856 38.7353194,47.8367191 47.8835909,52.4607212 C41.8869707,43.4274953 29.5831436,40.6937123 28.0478916,57.1923582 Z",
    id: "Path-116",
    fill: "#57E295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1637103,57.1923582 L27.6751525,57.1923582 C34.1197035,48.0779082 36.8905412,44.1064703 43.5597821,36.3229372 C34.7741294,39.6199247 25.7558934,44.1064703 24.1637103,57.1923582 Z",
    id: "Path-117",
    fill: "#28C76F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-85",
    transform: "translate(7.384615, 55.812500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#333333",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.28173518,-0.977871883 L11.6218526,-0.977871883 C4.00803723,16.4583352 19.0267352,26.7841096 11.6218526,44.1546766 L-4.28173518,44.1546766 L-4.28173518,-0.977871883 Z",
    id: "Rectangle",
    fill: "#857AF9",
    mask: "url(#mask-6)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemand);
export default __webpack_public_path__ + "static/media/demand.2ca8b6b19d0353a43c9a5bed25975537.svg";
export { ForwardRef as ReactComponent };